<adapt-feature-guidance [configItem]="configItem">
    <p>Team assessment has been designed to assess your teams current level of performance in order to identify opportunities in improve the
        team's effectiveness</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem"
                             [team]="team"
                             (featureChange)="currentStatus = $event">
    <adapt-configure-cadence-frequency [type]="CulturalActivityType.TeamAssessment"
                                       [teamId]="team?.teamId"
                                       title="Assessment frequency">
        <div class="text-muted small">
            Individual teams can set their own frequency for their assessments.
            @if (team) {
                This overrides the organisation default.
            } @else {
                This will be used as the default otherwise.
            }
        </div>
    </adapt-configure-cadence-frequency>
</adapt-feature-configuration>

<adapt-display-impact-surveys [hasChanges]="configurationService.hasChanges()"
                              [currentFeatureStatus]="currentStatus"
                              [team]="team"
                              [surveyType]="surveyType"></adapt-display-impact-surveys>
